import type * as React from 'react'
import { CheckboxField } from '@sunwebgroup/uds-ui/fields/checkbox-field'

export interface EditRoomParticipantItemProps {
  id: string
  name: string
  bookingCustomerId: number
  isSelected: boolean
  isDisabled: boolean
  onToggle: (bookingCustomerId: number) => void
}

export function EditRoomParticipantItem({
  name,
  bookingCustomerId,
  isSelected,
  isDisabled,
  onToggle,
}: EditRoomParticipantItemProps) {
  return (
    <CheckboxField
      label={name}
      checked={isSelected}
      onCheckedChange={() => onToggle(bookingCustomerId)}
      variant="outlined"
      disabled={isDisabled}
    />
  )
}
